/**
 * TaskType registry (spec §9.9, I-9): built-ins `task`, `recurring`, `note`, `counter` register here
 * exactly like plugins. A type decides what "done" means (`onDone`), which PropDefs it adds, and how
 * a row/card/detail renders (renderers arrive with the widgets that need them).
 */
import type { ComponentType } from "react";
import type { LoroDoc } from "loro-crdt";
import type { Level, PropDef, Task } from "../core/schema";

export interface TaskTypeCtx {
  doc: LoroDoc;
  now: number;
}

export interface TaskType {
  id: string;
  /** i18n key */
  label: string;
  icon: string;
  level: Level;
  propDefs: PropDef[];
  computed?: Record<string, (task: Task, ctx: TaskTypeCtx) => unknown>;
  onCreate?(task: Task, ctx: TaskTypeCtx): void;
  /** `keepOpen` (recurring) or `close` (default) */
  onDone?(task: Task, ctx: TaskTypeCtx): "keepOpen" | "close";
  /** true when the type has a done state at all (notes do not) */
  completable: boolean;
  Renderer?: ComponentType<{ task: Task; ctx: TaskTypeCtx; variant: "row" | "card" | "detail" }>;
  quickAddTokens?: string[];
}

const registry = new Map<string, TaskType>();

export function registerTaskType(t: TaskType): void {
  registry.set(t.id, t);
}

export function getTaskType(id: string): TaskType | undefined {
  return registry.get(id);
}

export function listTaskTypes(): TaskType[] {
  return [...registry.values()];
}
